import { render, staticRenderFns } from "./editAndDeleteRole.vue?vue&type=template&id=016adf42"
import script from "./editAndDeleteRole.vue?vue&type=script&lang=js"
export * from "./editAndDeleteRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports